import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ShoppingBagFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M13.56 6.92V5.08C13.56 4.2 12.86 3.48 12 3.48C11.14 3.48 10.44 4.2 10.44 5.08V6.92H13.56ZM4.76 19.86L5.46 6.92H8.84V5.08C8.84 3.28 10.26 1.84 12 1.84C13.74 1.84 15.16 3.28 15.16 5.08V6.92H18.54L19.24 19.86H4.76Z" />
    </SvgIcon>
  );
});
